import type { ModificationProps } from 'bundles/ent-website/contentful/modules/MarketoModule';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { generateMktoFormId } from 'bundles/ent-website/contentful/modules/MarketoModule';

const concatSizeLicense = ({ mktoFormId }: ModificationProps) => {
  const licenseCountInput = document.querySelector(
    `#${generateMktoFormId(mktoFormId)} select[name="Self_reported_employees_to_buy_for__c"]`
  );
  const companySizeInput = document.querySelector(
    `#${generateMktoFormId(mktoFormId)} select[name="Employee_Range__c"]`
  );

  const licenseCountInputEl = licenseCountInput as HTMLSelectElement;
  const companySizeInputEl = companySizeInput as HTMLSelectElement;

  if (!licenseCountInputEl?.value || !companySizeInputEl?.value) {
    return;
  }

  const concattedValue = `NOL:${licenseCountInputEl.value}~CS:${companySizeInputEl.value}`;

  const concatFieldInput = document.querySelector(
    `#${generateMktoFormId(mktoFormId)} input[name="orgSizeAndLicenseCount"]`
  );
  const concatFieldInputEl = concatFieldInput as HTMLInputElement;

  if (!concatFieldInputEl) {
    return;
  }

  concatFieldInputEl.value = concattedValue;
};

export { concatSizeLicense };
